module.exports = __webpack_public_path__ + "img/dianzishangwu.8196ec71.png";